import { SvgIcon } from '@mui/material';
import { ResponsiveButton } from 'components/buttons';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import { Icons } from 'greener-ui-library';

export default function Home() {
  const { t } = useTranslation();

  const to = JSON.parse(window.localStorage.getItem('projectView')) ?? '/projects';

  return (
    <ResponsiveButton
      data-testid="projects-navigation"
      color="inherit"
      component={RouterLink}
      to={to}
      breakpoint="sm"
      icon={() => (
        <SvgIcon sx={{ fontSize: 24 }}>
          <Icons.Project />
        </SvgIcon>
      )}
    >
      {`${t('navigation.projects')}`}
    </ResponsiveButton>
  );
}
